import {Sandwich} from './sandwich';
import 'latest-createjs';

const menu = {};
const buttonRoot = document.getElementById('sandwich-mobile');
let sandwich;

const animation = {
    elements: Array.from(document.querySelectorAll('.mobile__menu .menu__pop-up .pop-up__links .a-reveal')),
    socialElements: Array.from(document.querySelectorAll('.mobile__menu .menu__pop-up .share-list .a-reveal')),
    timeout: 125
};

const menuItems = Array.from(document.querySelectorAll('.mobile__menu .menu__pop-up .pop-up__links [data-section]'));

const openAnimation = () => {
    setTimeout(() => {
        animation.elements.forEach((elem, index) => {
            setTimeout(() => {
                elem.classList.add('a-reveal-done')
            }, animation.timeout * (index + 1));
        });

        animation.socialElements.forEach((elem, index) => {
            setTimeout(() => {
                elem.classList.add('a-reveal-done')
            }, animation.timeout * (index + 1));
        });
    }, 300);
};

const closeAnimation = () => {
    animation.elements.forEach(elem => {
        setTimeout(() => {
            elem.classList.remove('a-reveal-done');
        }, 300);
    });
    animation.socialElements.forEach(elem => {
        setTimeout(() => {
            elem.classList.remove('a-reveal-done');
        }, 300);
    });
};

if (buttonRoot) {
    sandwich = new Sandwich(buttonRoot);
    sandwich.opened = document.body.dataset.menuMobile === 'opened' ? true : false;

    sandwich.on('toggle', status => {
        document.body.dataset.menuMobile = status;
    });

    sandwich.on('open', () => {
        openAnimation();
    });

    sandwich.on('close', () => {
        closeAnimation();
    });
}

menu.open = () => {
    if (!sandwich) return;
    sandwich.opened = true;
}

menu.close = () => {
    if (!sandwich) return;
    sandwich.opened = false;
}


menu.setCurrent = section => {
    menuItems.forEach(function (el) {
        el.classList.remove('active');
    })

    const el = document.querySelector(`.mobile__menu .menu__pop-up .pop-up__links [data-section='${section}']`);
    if (el) el.classList.add('active');
}

if (menuItems) {
    menuItems.forEach(function (el) {
        el.addEventListener('click', () => {
            const evt = new window.createjs.Event('request');
            evt.section = el.dataset.section;
            menu.dispatchEvent(evt);
        });
    });
}



window.createjs.EventDispatcher.initialize(menu);
module.exports = menu;



// WEBPACK FOOTER //
// ./js/menu-mobile.js